import { render, staticRenderFns } from "./filter-sidebar.vue?vue&type=template&id=a22cc276&scoped=true&"
import script from "./filter-sidebar.vue?vue&type=script&lang=js&"
export * from "./filter-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./filter-sidebar.vue?vue&type=style&index=0&id=a22cc276&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22cc276",
  null
  
)

export default component.exports